import React from "react";
import { StyledTab, StyledTabItem } from "./Tab.styled";
import { RoundedContainer } from "../RoundedContainer/RoundedContainer";
import { IconManager } from "../core/IconManager/IconManager";
import { FontWeightEnum, IconSizeEnum, TabMenu } from "../../types/AppTypes";
import { BodyTyp } from "../Typography/Typography";
import { ReactComponent as MaximizeIcon } from "../../icons/maximize.svg";
import { ReactComponent as MinimizeIcon } from "../../icons/minimize.svg";

type TabProps = {
  children: React.ReactNode;
  setTabSelected: (id: number) => void;
  tabSelected: number;
  tabMenu: TabMenu[];
  expandControl?: {
    expanded: boolean;
    toggle: () => void;
  };
  rightContent?: React.ReactNode;
  confirmLeave?: (action: () => void) => void;
};

export const Tab = ({
  children,
  setTabSelected,
  tabSelected,
  tabMenu,
  expandControl,
  rightContent,
  confirmLeave,
}: TabProps) => {
  const handleSwitchTab = (item: TabMenu) => {
    confirmLeave
      ? confirmLeave(() => setTabSelected(item.id))
      : setTabSelected(item.id);
  };

  return (
    <StyledTab>
      <div className="tabs-container">
        <div className="left-tabs">
          {tabMenu.map((item, index) => {
            const isActive = tabSelected === item.id;
            return (
              <StyledTabItem
                $active={isActive}
                onClick={() => handleSwitchTab(item)}
                key={`${item.label}${index}`}
              >
                {item.icon && (
                  <IconManager size={IconSizeEnum.SMALL} marginRight={10}>
                    {item.icon}
                  </IconManager>
                )}
                <BodyTyp
                  fontWeight={
                    isActive ? FontWeightEnum.SEMIBOLD : FontWeightEnum.MEDIUM
                  }
                >
                  {item.label}
                </BodyTyp>
              </StyledTabItem>
            );
          })}
        </div>
        <div className="right-tabs">
          {rightContent && <div className="right-content">{rightContent}</div>}
          {expandControl && (
            <StyledTabItem
              $active={true}
              onClick={() => expandControl.toggle()}
            >
              <IconManager size={IconSizeEnum.MEDIUM}>
                {expandControl.expanded ? <MinimizeIcon /> : <MaximizeIcon />}
              </IconManager>
            </StyledTabItem>
          )}
        </div>
      </div>
      <RoundedContainer>{children}</RoundedContainer>
    </StyledTab>
  );
};
